import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context'

export default function WinningModal() {

  const { sessionResult, setSessionResult } = useContext(Context)
  const [result, setResult] = useState(false);

  useEffect(() => {
    if (Object.keys(sessionResult).length > 0) {
      console.log(sessionResult)
      setResult(true)
    }
  }, [sessionResult])

  return (
    <>
      {result &&
        <div className="modal-overlay">
          <div className="modal1">
            <div className="modal1-content">
              <div className="victory-banner">
                <span className="victory-text">Winning Number</span>
              </div>
              <div className="score">
                <span className="score-value">{sessionResult?.winning_number}</span>
              </div>
              <button className="close-button1" onClick={() => { setResult(false); setSessionResult({}) }}>Close</button>
            </div>
            <div className="background-balls">
              <div className="ball red"></div>
              <div className="ball blue"></div>
              <div className="ball yellow"></div>
              <div className="ball red2"></div>
              <div className="ball blue2"></div>
            </div>
          </div>
        </div>
      }
    </>
  )
}
